import styled from 'styled-components';

export const Wrap = styled.div`
  background:${props=>props.bgColor};
  height:.97rem;
  margin-top:-.12rem;
  position:relative;
  text-align:center;
  line-height:.97rem;
  color:#005bab;
`
 


 





